export const random = (min, max) => {
  return Math.random() * (max - min) + min;
};

export const randomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const randomBool = () => {
  return Math.random() > 0.5;
};

export { default as alias } from "./alias.js";
export { default as subdivide } from "./subdivide.js";
